import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PurchaseCancel.module.css';
import { useTranslation } from 'react-i18next';

const PurchaseCancel = () => {
  const { t } = useTranslation('purchaseResult');
  return (
    <div className={styles.container}>
      <h1>{t('cancel.title')}</h1>
      <p>{t('cancel.body')}</p>
      <p>{t('cancel.guide')}</p>

      <Link to="/" className={styles.button}>
        {t('cancel.backToHome')}
      </Link>
    </div>
  );
};

export default PurchaseCancel;
